import { RaceProgram } from '@/lib/apollo/types/gen/graphql';

export enum DayType {
  Today = 'today',
  PreviousDay = 'previousDay',
  NextDay = 'nextDay',
}

export enum RaceType {
  Singlerace = 'singlerace',
  Multirace = 'multirace',
}

export enum LotteryType {
  Chariloto = 'chariloto',
  Dokanto = 'dokanto',
}

export enum BannerType {
  Campaign = 'campaign',
  External = 'external',
  Gamble = 'gamble',
}

export type RecentRacePrograms = { [key in DayType]: RaceProgram[] };
